import { Component, Mixins, Ref } from "vue-property-decorator";

import { TemplateDeleteModal } from "@/components/Agencies/ReportBuilder";
import { TEMPLATES_DELETED_MESSAGE } from "@/components/Agencies/ReportBuilder/reportTemplate";
import ReportTemplateCrudMixin from "@/mixins/ReportBuilder/ReportTemplateCrudMixin";
import { ReportTemplate } from "@/models";
import ToastInvoker, { responseErrorMessage } from "@/utils/ToastInvoker";

@Component
export default class TemplateBulkDeleteMixin extends Mixins(
  ReportTemplateCrudMixin
) {
  @Ref("bulkDeleteConfirmModal")
  readonly bulkDeleteConfirmModal?: TemplateDeleteModal;

  bulkDeleteMode = false;
  bulkSelectedTemplates: ReportTemplate[] = [];

  get bulkSelectedIds(): string[] {
    return this.bulkSelectedTemplates.map((t) => t.id);
  }

  enterBulkDeleteMode() {
    this.bulkDeleteMode = true;
  }

  exitBulkDeleteMode() {
    this.bulkDeleteMode = false;
    this.bulkSelectedTemplates = [];
  }

  openBulkDeleteConfirm() {
    if (!this.bulkSelectedIds.length) return;
    this.bulkDeleteConfirmModal?.show();
  }

  onSelectionChange(templates: ReportTemplate[]) {
    this.bulkSelectedTemplates = templates;
  }

  async doBulkDeleteTemplates() {
    if (this.deletingTemplates) return;
    const ids = this.bulkSelectedIds;
    if (!ids.length) return;
    this.deletingTemplates = true;
    try {
      await this.bulkDestroyReportTemplates(this.profile.slug, ids, true);
      this.bulkDeleteConfirmModal?.hide();
      if (
        this.pendingTemplateId !== null &&
        ids.includes(this.pendingTemplateId)
      ) {
        this.deselectTemplate();
      }
      this.exitBulkDeleteMode();
      this.invalidateTemplatesCache();
      this.invalidateAutomaticReportsCache();
      const refresh = this.templateSelect?.refresh();
      await this.templateActionModal?.dialog(TEMPLATES_DELETED_MESSAGE);
      await refresh;
    } catch (error) {
      ToastInvoker.errorToast(responseErrorMessage(error), error);
    } finally {
      this.deletingTemplates = false;
    }
  }
}
